<div class="container">
    <div class="text-center hidden-scrollbar">
        <h3>We are sorry, but this page was not found!</h3>
        <img src="/assets/images/page-not-found.gif">
    </div>
    <div class="row">
        <div class="col-2 offset-5">
            <button class="btn btn-success btn-lg" (click)="homePage()">Back to Homepage</button>
        </div>
    </div>
</div>